import * as actionTypes from '../constants/userActionTypes';
import * as api from '../api';
import { toast } from "react-toastify";

/**
* function for loadSupportingDocs
* @param {*} data User data 
* @description get user infromation
* @param {function} loadSupportingDocs loadSupportingDocs function
*/
export const loadSupportingDocs = id => async dispatch => {
    try {
        dispatch({ type: actionTypes.LOAD_PROJECT_SUPPORTING_DOCS_REQUEST })
        const { data } = await api.editDocument(id);
        dispatch({ type: actionTypes.LOAD_PROJECT_SUPPORTING_DOCS_SUCCESS, payload: data })

    } catch (err) {
        console.log(err)
        dispatch({ type: actionTypes.LOAD_PROJECT_SUPPORTING_DOCS_FAIL, payload: err.response.data })
    }
}

/**
* function for updateProjectSupportingDocs
* @param {*} data User data 
* @description get user infromation
* @param {function} updateProjectSupportingDocs updateProjectSupportingDocs function
*/
export const updateProjectSupportingDocs = (formData) => async dispatch => {
    try {
        dispatch({ type: actionTypes.LOAD_PROJECT_SUPPORTING_DOCS_REQUEST })
        const { data } = await api.updateSupportingDocsProject(formData);
        toast.success(data.message)
        dispatch({ type: actionTypes.LOAD_PROJECT_SUPPORTING_DOCS_SUCCESS, payload: data })
    } catch (err) {
        dispatch({ type: actionTypes.LOAD_PROJECT_SUPPORTING_DOCS_FAIL, payload: err.response.data })
    }
}
/**
* function for user update Document
* @param {*} data User data 
* @description update user infromation
* @param {function} updateDocument updateDocument function
*/
export const updateDocumentByOwner = formData => async (dispatch, getState) => {
    try {
        dispatch({ type: actionTypes.LOAD_PROJECT_SUPPORTING_DOCS_REQUEST })
        const { data } = await api.updateDocumentByOwner(formData)
        toast.success(data.message);
        dispatch({ type: actionTypes.LOAD_PROJECT_SUPPORTING_DOCS_SUCCESS, payload: data })
    } catch (err) {
        console.log(err.response.data.message)
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.LOAD_PROJECT_SUPPORTING_DOCS_FAIL, payload: err.response.data.message })
    }
}
/**
* function for user update Document
* @param {*} data User data 
* @description update user infromation
* @param {function} updateDocument updateDocument function
*/
export const updateFileNameByOwner = formData => async (dispatch, getState) => {
    try {
        dispatch({ type: actionTypes.LOAD_PROJECT_SUPPORTING_DOCS_REQUEST })
        const { data } = await api.updateFileNameAPIByOwner(formData)
        toast.success(data.message);
        dispatch({ type: actionTypes.LOAD_PROJECT_SUPPORTING_DOCS_SUCCESS, payload: data })
    } catch (err) {
        console.log(err.response.data.message)
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.LOAD_PROJECT_SUPPORTING_DOCS_FAIL, payload: err.response.data.message })
    }
}
/**
* function for user documentApprovedByApprover
* @param {*} data form data and history
* @description user documentApprovedByApprover
* @param {function} documentApprovedByApprover documentApprovedByApprover function
*/

export const documentApprovedByApprover = (id) => async dispatch => {
    try {
        dispatch({ type: actionTypes.LOAD_PROJECT_SUPPORTING_DOCS_REQUEST })
        const { data } = await api.updateDocumentApprove(id);
        toast.success(data.message);
        dispatch({ type: actionTypes.LOAD_PROJECT_SUPPORTING_DOCS_SUCCESS, payload: data })

    } catch (err) {
        console.log('error is: ', err.response?.data)
        toast.error(err.response?.data?.message);
        dispatch({ type: actionTypes.LOAD_PROJECT_SUPPORTING_DOCS_FAIL, payload: err.response?.data?.message })
    }
}



export const documentRejectedByApprover = (formData) => async dispatch => {
    try {
        dispatch({ type: actionTypes.LOAD_PROJECT_SUPPORTING_DOCS_REQUEST })
        const { data } = await api.rejectDocuments(formData)
        dispatch({ type: actionTypes.LOAD_PROJECT_SUPPORTING_DOCS_SUCCESS, payload: data })
        toast.success(data.message);
    } catch (err) {
        console.log(err)
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.LOAD_PROJECT_SUPPORTING_DOCS_FAIL, payload: err.response.data.message })
    }
}

/**
* function for user update Document
* @param {*} data User data 
* @description update user infromation
* @param {function} sendUpdateDocumentRequestByOwners sendUpdateDocumentRequestByOwners function
*/
export const sendUpdateDocumentRequestByOwners = id => async () => {
    try {
        const { data } = await api.requestDocumentEdit(id)
        toast.success(data.message);
    } catch (err) {
        console.log(err.response.data.message)
        toast.error(err.response.data.message);
    }
}

/**
* function for user update acceptDocumentUpdateRequestByUser
* @param {*} data User data 
* @description update user infromation
* @param {function} acceptDocumentUpdateRequestByUser acceptDocumentUpdateRequestByUser function
*/
export const acceptDocumentUpdateRequestByUser = (formData, history) => async () => {
    try {
        const { data } = await api.acceptDocumentUpdateRequestByUser(formData)
        toast.success(data.message);
        history.push('/')
    } catch (err) {
        console.log(err.response.data.message)
        toast.error(err.response.data.message);
    }
}
/**
* function for project destroyprojectSupportingDocs Type
* @param {*} data destroyprojectSupportingDocs Type data 
* @description get destroyprojectSupportingDocs Type infromation
* @param {function} destroyprojectSupportingDocsType destroyprojectSupportingDocs Type function
*/
export const destroyProjectSupportingDocs = (id) => async dispatch => {
    try {
        dispatch({ type: actionTypes.LOAD_PROJECT_SUPPORTING_DOCS_REQUEST })
        const { data } = await api.deleteSupportingDocs(id);
        toast.success(data.message);
        dispatch({ type: actionTypes.LOAD_PROJECT_SUPPORTING_DOCS_SUCCESS, payload: data })
    } catch (err) {
        toast.error(err.response.data.message)
        dispatch({ type: actionTypes.LOAD_PROJECT_SUPPORTING_DOCS_FAIL, payload: err.response.data })
    }
}